(function () {
    'use strict';

    angular
        .module('app')
        .controller('CampaignsController', CampaignsController);

    CampaignsController.$inject = ['$state',];

    function CampaignsController($state) {
        // var vm = this;


        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'campaigns') {
                $state.go('campaigns.list');
            }
        }
    }
})();